import * as Sentry from '@sentry/react';
import configJson from './auth-config.json';
import axios from 'axios';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom';
import { config } from 'packages/config';
import { useEffect } from 'react';

export const getConfig = () => ({
  domain: configJson.domain,
  clientId: configJson.clientId,
  secret: configJson.secret,
  audience: configJson.audience,
  everbeatBaseUrl: configJson.everbeatBaseUrl,
});

export const setAxiosHeaders = (token: string) => {
  try {
    axios.defaults.headers.common.Authorization = 'Bearer ' + token;
  } catch (error) {
    console.warn('error configuring axios: ', error);
  }
};
export const clearAxiosHeaders = () => {
  delete axios.defaults.headers.common.Authorization;
};

const getSentrySampleRate = (environment: string) => {
  const tracesMap = {
    development: 0.1,
    staging: 0.5,
    production: 1.0,
  };

  return tracesMap[environment] ?? 1.0;
};

export const initSentry = (sentry: typeof Sentry) => {
  const environment = config.ENV.APP.ENVIRONMENT;
  const sampleRate = getSentrySampleRate(environment);
  sentry.init({
    dsn: config.ENV.APP.SENTRY_DSN,
    integrations: [
      sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      sentry.replayIntegration(),
    ],
    environment,
    tracesSampleRate: sampleRate,
    tracePropagationTargets: [`^${new RegExp(config.ENV.API.EVERBEAT_BASE_URL)}`],
    replaysSessionSampleRate: sampleRate,
    replaysOnErrorSampleRate: sampleRate === 1 ? 1 : 0,
  });
};
